import React, { useEffect } from 'react';

type LinkInvitationStep2LegalProps = {
  onNext: ( values:any ) => void
};

function LinkInvitationStep2( { onNext }: LinkInvitationStep2LegalProps ) {
  useEffect( () => {
    setTimeout( () => {
      onNext( {} );
    } );
  }, [] );

  return (
    <>
      <h2 className="text--black4 mt-3">Cargando perfil</h2>
      <p className="mt-5 pt-2" />
    </>
  );
}

export default LinkInvitationStep2;
